import { connect, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { setSnackbar } from 'redux/index';
import { setInviteUser } from 'redux/reducers';
import { TextFieldRow } from 'components';
import { InviteRoleSelector } from './InviteRoleSelector';
import InviteAssignment from './InviteAssignment';
import styles from '../sendInvite.module.css';

function InviteFormUpdated(props) {
	const { type, managerMap, branchMap, managerList } = props;
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const [manager, setManager] = useState('');
	const [branch, setBranch] = useState('');
	const [role, setRole] = useState(
		type === 'socialWorker' ? 'social-worker' : type
	);

	const dispatch = useDispatch();

	useEffect(() => {
		const user = {
			email: email,
			firstName: firstName,
			lastName: lastName,
			branchId: branch,
			manager: manager,
			role: role,
		};

		dispatch(setInviteUser(user));
	}, [email, firstName, lastName, manager, branch, role]);

	const selectManager = (e) => {
		const { value } = e.target;
		let index = managerList.findIndex((val) => {
			return val.id === e.target.value;
		});
		setManager(value);
		setBranch(managerList[index].branch?.id);
	};

	const selectBranch = (e) => {
		setBranch(e.target.value);
	};

	return (
		<div className={styles.inviteFormContainer}>
			<>
				<InviteRoleSelector role={role} onChange={setRole} />

				<TextFieldRow
					required={true}
					name='Email'
					label='Email'
					margin='normal'
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
				<TextFieldRow
					name='First Name'
					label='First Name'
					variant='outlined'
					required={true}
					value={firstName}
					onChange={(e) => setFirstName(e.target.value)}
				/>
				<TextFieldRow
					name='Last Name'
					label='Last Name'
					variant='outlined'
					required={true}
					value={lastName}
					onChange={(e) => setLastName(e.target.value)}
				/>
				{role === 'social-worker' && managerMap ? (
					<InviteAssignment
						label='Manager'
						required={false}
						value={manager}
						onSelect={selectManager}
						listMap={managerMap}
					/>
				) : null}
				{role === 'manager' ? (
					<InviteAssignment
						label='Branch'
						required={true}
						value={branch}
						onSelect={selectBranch}
						listMap={branchMap}
					/>
				) : null}
			</>
		</div>
	);
}

export default connect(null, { setSnackbar })(InviteFormUpdated);
